module.exports = __webpack_public_path__ + "img/map_pc_6.c5f8fa94.png";